import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { GymProvider } from './contexts/GymContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { OnboardingProvider } from './contexts/OnboardingContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import OnboardingTour from './components/OnboardingTour';
import WelcomeModal from './components/WelcomeModal';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { RevenueSourcesPage } from './pages/RevenueSourcesPage';
import { GoalsPage } from './pages/GoalsPage';
import { PerformancePage } from './pages/PerformancePage';
import { SettingsPage } from './pages/SettingsPage';
import { ReportsPage } from './pages/ReportsPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { PaymentSuccessPage, PaymentCancelledPage } from './pages/PaymentPages';
import { AdminPage } from './pages/AdminPage';
import ROIPage from './pages/ROIPage';
import { CompromissosPage } from './pages/CompromissosPage';
import { FinancialDirectorPage } from './pages/FinancialDirectorPage';
import { ProjecaoPage } from './pages/ProjecaoPage';
import { FluxoCaixaPage } from './pages/FluxoCaixaPage';
import { SaudeFinanceiraPage } from './pages/SaudeFinanceiraPage';
import CaixaPage from './pages/CaixaPage';
import DREPage from './pages/DREPage';
import { GestaoReceitaPage } from './pages/GestaoReceitaPage';
import ConsolidadoPage from './pages/ConsolidadoPage';
import { HubPage } from './pages/HubPage';
import { PrivacyPage, TermsPage } from './pages/LegalPages';
import { CookieBanner } from './components/CookieBanner';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <GymProvider>
          <OnboardingProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/privacidade" element={<PrivacyPage />} />
                <Route path="/termos" element={<TermsPage />} />
                <Route
                  path="/areas"
                  element={
                    <ProtectedRoute>
                      <HubPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />
              <Route
                path="/saude-financeira"
                element={
                  <ProtectedRoute>
                    <SaudeFinanceiraPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/revenue"
                element={<Navigate to="/gestao-receita" replace />}
              />
              <Route
                path="/expenses"
                element={<Navigate to="/dre" replace />}
              />
              <Route
                path="/bills"
                element={<Navigate to="/dre" replace />}
              />
              <Route
                path="/revenue-sources"
                element={
                  <ProtectedRoute>
                    <RevenueSourcesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/goals"
                element={
                  <ProtectedRoute>
                    <GoalsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/performance"
                element={
                  <ProtectedRoute>
                    <PerformancePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    <ReportsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/roi"
                element={
                  <ProtectedRoute>
                    <ROIPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/compromissos"
                element={
                  <ProtectedRoute>
                    <CompromissosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/receita"
                element={<Navigate to="/gestao-receita" replace />}
              />
              <Route
                path="/projecao"
                element={
                  <ProtectedRoute>
                    <ProjecaoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fluxo-caixa"
                element={
                  <ProtectedRoute>
                    <FluxoCaixaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caixa"
                element={
                  <ProtectedRoute>
                    <CaixaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dre"
                element={
                  <ProtectedRoute>
                    <DREPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gestao-receita"
                element={
                  <ProtectedRoute>
                    <GestaoReceitaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assinatura"
                element={
                  <ProtectedRoute>
                    <SubscriptionPage />
                  </ProtectedRoute>
                }
              />
              {/* Payment pages don't require auth - user may have lost token during Stripe checkout */}
              <Route
                path="/pagamento/sucesso"
                element={<PaymentSuccessPage />}
              />
              <Route
                path="/pagamento/cancelado"
                element={<PaymentCancelledPage />}
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/geral"
                element={
                  <ProtectedRoute>
                    <ConsolidadoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/diretor-financeiro"
                element={
                  <ProtectedRoute>
                    <FinancialDirectorPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
            {/* Onboarding Components - must be inside BrowserRouter */}
            <WelcomeModal />
            <OnboardingTour />
            <CookieBanner />
          </BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: 'rgba(24, 24, 27, 0.95)',
                color: '#fff',
                border: '1px solid rgba(168, 201, 74, 0.2)',
              },
            }}
          />
        </OnboardingProvider>
        </GymProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
